import { ApSelect, colors } from '@alixpartners/ui-components';
import styled, { css } from 'styled-components';

export const LoaderWrapper = styled.div`
	width: 100%;
	text-align: center;
	padding: 15% 0;
`;
export const StyledSelect = styled.select`
	padding: 5px;
	font-size: 12px;
	width: 100%;
	border: none;
	outline: none;
	background-color: transparent;

	&:focus {
		border-color: #007bff;
	}
`;
export const TooltipContent = styled.div`
	font-size: 14px;
	text-align: left;
`;
export const EditButton = styled.button`
	border: none;
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}
`;
export const MainContent = styled.div`
	padding: 5px 32px;
	width: 100%;
	overflow: auto;
`;

export const DownloadLink = styled.a`
	font-size: 13px;
	font-weight: 500;
	text-transform: uppercase;
	color: ${colors.grey8};
	padding: 0 8px;
	height: 36px;
	line-height: 36px;
	display: inline-block;

	&:hover {
		background: #ecf3ea;
	}
`;
export const Button = styled.button`
	flex: 1;
	padding: 10px;
	border: none;
	outline: none;
	font-size: 16px;
	background-color: transparent;
	cursor: pointer;
	position: relative;
	&::after {
		content: '';
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: ${props => (props.isSelected ? '1px' : '0')};
		background-color: green;
		transition: height 0.3s;
	}
	&:hover::after {
		height: 1.5px;
	}
`;
export const ButtonWrapper = styled.div`
	display: flex;
`;

export const Select = styled(ApSelect)`
	width: 384px;
	min-width: 100px !important;
	${({ small }) =>
		small &&
		css`
			max-height: 35px !important;
			font-size: 14px !important;
			min-width: 100px !important;
		`};
`;

export const DateRangeWrapper = styled.div`
	margin-right: auto;
	margin-top: 0.25%;
	margin-left: 0.5%;
	.ap-month-picker > div:nth-child(2) {
		top: 18%;
		right: 54%;
	}
`;

export const DatePicker = styled.input`
	border: none;
	&::-webkit-clear-button {
		display: none;
	}
`;

export const Ribbon = styled.div`
	background-color: ${colors.white};
	display: flex;
	flex-direction: row;
	align-items: center;
	border: 1px solid ${colors.grey200};
	height: 32px;
	position: sticky;
	margin-top: 0.25%;
	top: 0;
	z-index: 1;
`;

export const RibbonText = styled.div`
	font-size: 14px;
	font-weight: 500;
	letter-spacing: 0.3px;
	cursor: pointer;
	color: ${colors.grey6};
`;

export const TableWrapper = styled.div`
	.ag-theme-balham {
		.ag-header-cell {
			text-align: center;
		}
		.ag-header-row {
			.ag-header-cell {
				.ag-cell-label-container {
					justify-content: center;

					.ag-header-cell-label {
						flex: unset;
					}
				}
			}
		}
		.ag-row {
			.ag-cell {
				text-align: center;
			}
		}
	}
`;
